<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <app-modal-back></app-modal-back>
    </ion-buttons>
    <ion-title>{{ isNewAgreement ? 'Offer a new' : 'Update' }} agreement</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content
  *ngIf="form"
  data-testid="agreement-form-step4"
>
  <!-- SUPPORT TERMS -->
  <app-agreement-support-terms-form
    [isPreFilled]="isPreFilled"
    [terms]="form.value"
    (valueChange)="onSupportTermsChange($event)"
  ></app-agreement-support-terms-form>

  <!-- NEED MORE HELP -->
  <app-agreement-need-more-help-form [otherUser]="otherUser"></app-agreement-need-more-help-form>
</ion-content>
<ion-footer>
  <ion-toolbar>
    <ion-grid>
      <ion-row>
        <ion-col>
          <mable-button
            class="ion-no-margin"
            category="outline"
            expand="block"
            (onClick)="closeModal()"
            >Cancel
          </mable-button>
        </ion-col>
        <ion-col>
          <mable-button
            class="ion-no-margin"
            expand="block"
            category="orange-500"
            (onClick)="submit()"
            [throttleTime]="1000"
            data-testid="agreement-form-step4-offer-send"
          >
            {{ isNewAgreement ? 'Offer' : 'Send' }}</mable-button
          >
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-toolbar>
</ion-footer>
